<app-create-section
	class="col-span-12 xl:col-span-8 xl:col-start-1 xl:row-span-3 xl:row-start-1"
	title="Overview"
	[testHook]="testHooks.OverviewCreateSection"
>
	<section class="flex w-full h-full justify-between px-6 py-4">
		<div class="flex flex-col">
			<h4>Address</h4>
			<app-aps-edit-anchor
				class="mb-4"
				[text]="address$ | async | address"
				fragment="address"
				[href]="CreateMatterAPS_URL$ | async"
				[testHook]="testHooks.ApsEditAnchor"
			/>

			<div class="flex items-center justify-start flex-wrap">
				<h5 class="text-sm font-semibold mr-2 xl:text-lg">Property Type</h5>
				<app-aps-edit-anchor
					[text]="propertyTypeLabel$ | async"
					[hiddenIconOnBlur]="true"
					fragment="property-type"
					[href]="CreateMatterAPS_URL$ | async"
					comma=", "
					class="flex after:content-[attr(comma)]"
					[testHook]="testHooks.ApsEditAnchor1"
				/>

				<app-aps-edit-anchor
					[text]="propertyTypeStatus$ | async | titlecase"
					fragment="property-type"
					[href]="CreateMatterAPS_URL$ | async"
					[testHook]="testHooks.ApsEditAnchor2"
				/>
			</div>
		</div>
		<a
			*ngIf="(locationMapLink$ | async)?.trim() as locationMapLink"
			[href]="locationMapLink"
			target="_blank"
			rel="noopener noreferrer"
			class="flex"
			[testHook]="testHooks.Link"
		>
			<img
				class="rounded-md aspect-video"
				*ngIf="(locationMapUrl$ | async)?.trim() as locationMapUrl"
				[src]="locationMapUrl"
				alt="Map illustrating the location of the property"
			/>
		</a>
	</section>
</app-create-section>

<app-create-section
	class="hidden xl:block xl:col-start-9 xl:row-span-1 xl:col-span-4"
	title="Quick Action"
	[testHook]="testHooks.QuickActionCreateSection"
>
	<section class="flex pt-4 flex-col gap-2">
		<span class="h3">Begin Title Search</span>
		<ui-anchor
			icon="chevron-right"
			[href]="MatterTitleSearchURL$ | async"
			iconPosition="end"
			[testHook]="testHooks.Anchor"
		>
			Start Search
		</ui-anchor>
		<ui-anchor
			*ngIf="
				(hasDoneAPSAiScraping$ | async) && (isClientIntakeEnabled$ | async)
			"
			icon="chevron-right"
			[href]="MatterPartiesClients$ | async"
			iconPosition="end"
			[testHook]="testHooks.Anchor"
		>
			Start Client Intake
		</ui-anchor>
	</section>
</app-create-section>
<app-create-section
	class="col-span-12 sm:row-start-2 xl:row-start-2 xl:row-span-8 xl:col-start-9 xl:col-span-4"
	title="Quick Contacts"
	[testHook]="testHooks.QuickContactsCreateSection"
>
	<section class="flex gap-4 my-6 xl:flex-col">
		<div
			*ngFor="let quickContact of quickContacts$ | async"
			class="flex flex-1 flex-col gap-6"
		>
			<span class="h3">{{ quickContact.cardName }}</span>
			<div
				class="bg-gray-100 flex h-full flex-col justify-between gap-2 rounded-lg p-4 xl:h-auto xl:min-h-64"
			>
				<div
					*ngFor="let info of quickContact.information"
					class="flex flex-col"
				>
					<div class="flex gap-2 items-center mb-2">
						<span class="h4">{{ info.title }}</span>
						<i-tabler [name]="info.icon" class="w-4 h-4" />
					</div>
					<ng-container *ngIf="info.name as name; else missingInfo">
						<app-aps-edit-anchor
							[text]="name | titlecase"
							[fragment]="quickContact.fragment"
							[href]="CreateMatterAPS_URL$ | async"
							class="font-bold"
							[testHook]="testHooks.ApsEditAnchor3"
						/>

						<span class="flex gap-2 items-center justify-start">
							<i-tabler name="mail" class="h-4 w-4" />
							<a
								*ngIf="info.email as email; else missingInfo"
								href="mailto:{{ email }}"
								class="px-2 hover:underline"
								[testHook]="testHooks.Link1"
							>
								{{ email }}
							</a>
						</span>
						<span class="flex gap-2 items-center justify-start">
							<i-tabler name="phone" class="h-4 w-4" />
							<a
								*ngIf="info.phone as phone; else missingInfo"
								href="tel:{{ phone }}"
								class="px-2 hover:underline"
								[testHook]="testHooks.Link2"
							>
								{{ phone }}
							</a>
						</span>
					</ng-container>
				</div>

				<ng-template #missingInfo>
					<app-missing-info-anchor
						[href]="
							(CreateMatterAPS_URL$ | async) + '#' + quickContact.fragment
						"
						[testHook]="testHooks.MissingInfoAnchor"
					/>
				</ng-template>
			</div>
		</div>
	</section>
</app-create-section>

<app-create-section
	*ngFor="let infoCard of infoCards"
	class="col-span-12 sm:col-span-6 xl:row-span-3 xl:col-span-4"
	[title]="infoCard.title"
	[testHook]="testHooks.InfoCardTitleCreateSection"
>
	<section class="flex justify-start gap-2 items-center h-full">
		<ul class="flex flex-col w-full gap-2 justify-start items-start xl:gap-8">
			<li
				*ngFor="let infoElement of infoCard.infoArray$ | async"
				class="flex w-full"
			>
				<h4 class="text-sm flex-1 font-semibold m-0 2xl:text-lg">
					{{ infoElement.title }}
				</h4>
				<app-aps-edit-anchor
					[text]="
						infoCard.usePipe === 'date'
							? (infoElement.value | date)
							: infoCard.usePipe === 'centsToDollars'
								? (infoElement.value | centsToDollars)
								: infoElement.value
					"
					[fragment]="infoElement.fragment"
					[href]="infoElement.href ?? (CreateMatterAPS_URL$ | async)"
					[testHook]="testHooks.ApsEditAnchor4"
				/>
			</li>
		</ul>
	</section>
</app-create-section>
